var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MPInstancesHub } from "@/api/RequestAxios/RequestAxiosHub";
import { packQueryParams, stringifyQueryParams } from "../utils";
import { UIModelProject, UIModelProjects } from "./project.model";
import { unpackProject, packProject, unpackProjects } from "./project.mapper";
var projectsURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects");
};
var ApiKeyURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/control/get_api_key");
};
var projectURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId);
};
export var getProjectsList = function (_a, queryParams) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(projectsURL({ partnerId: partnerId, clientId: clientId }), {
                        params: queryParams && packQueryParams(queryParams),
                        paramsSerializer: stringifyQueryParams,
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelProjects(unpackProjects(data))];
            }
        });
    });
};
export var getProject = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(projectURL({ partnerId: partnerId, clientId: clientId, projectId: projectId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelProject(unpackProject(data))];
            }
        });
    });
};
export var addProject = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(projectsURL({ partnerId: partnerId, clientId: clientId }), packProject(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelProject(unpackProject(data))];
            }
        });
    });
};
export var editProject = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.patch(projectURL({ partnerId: partnerId, clientId: clientId, projectId: projectId }), packProject(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackProject(data)];
            }
        });
    });
};
export var getApiKey = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(ApiKeyURL({ partnerId: partnerId, clientId: clientId, projectId: projectId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
//# sourceMappingURL=data:application/json;base64,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